import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Image } from '@fiverr-private/media';
import { containerClass } from './styles.ve.css';
import { PARTNER_LOGOS } from './constants';

const Partners: React.FC = () => (
  <Box display={{ default: 'none', md: 'block' }}>
    <Stack as="ul" direction="row" justifyContent="center" alignItems="center" wrap="nowrap" className={containerClass}>
      {PARTNER_LOGOS.map((logo, index) => (
        <Container as="li" height="100%" key={index}>
          <Image src={logo.src} alt={logo.alt} width="100%" height="100%" />
        </Container>
      ))}
    </Stack>
  </Box>
);

export default Partners;
